module.exports = __webpack_public_path__ + "static/salud-cb5583b0397cc6cf40b3bcea76622e05.svg";